import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import './Style.css';
import { convertTextValues } from '../../../shared/util/assessments';

type PainSliderProps = {
  questionid: string;
  width: string;
  textValues: string[];
  questionTitle: string;
  onSetValue: (value: { id: string; value: string }) => void;
  assessmentValues: Record<string, unknown>;
};

export function PainSlider({
  questionid,
  width,
  textValues,
  questionTitle,
  onSetValue,
  assessmentValues,
}: PainSliderProps) {
  const [textValue, setTextValue] = useState('');
  const [rangeValue, setRangeValue] = useState('3');
  const { t } = useTranslation();

  useEffect(() => {
    if (assessmentValues[questionid]) {
      const text = convertTextValues(assessmentValues[questionid].toString(), textValues);
      setTextValue(text);
      setRangeValue(assessmentValues[questionid].toString());
    } else {
      setTextValue(textValues[2]);
      onSetValue({ id: questionid, value: '3' });
    }
  }, []);

  const handleRangeChange = (event) => {
    const { value } = event.target;
    setRangeValue(value);
    setTextValue(convertTextValues(value, textValues));
    onSetValue({ id: questionid, value });
  };

  return (
    <div className={`req question_block${width} pain_slider_container`}>
      <fieldset id={questionid} data-input-type="pain-slider">
        <legend className="assessment_question_title">{questionTitle}</legend>
        <div className="answer_block fs-exclude">
          <div className="painSlider pain_slider" id={`${questionid}-pain-slider-container`}>
            <div className="leftLabel">{textValues[0]}</div>
            <div className="rightLabel">{textValues[4]}</div>
            <div className={`range-container value-${rangeValue}`}>
              <input
                type="range"
                min="1"
                max="5"
                value={rangeValue}
                onChange={handleRangeChange}
                id={`${questionid}_slider`}
                aria-valuetext={textValue}
                aria-label={`${questionTitle} ${t('slider.description.from')} ${textValues[0]} ${t('slider.description.to')} ${textValues[4]}`}
                data-uw-ignore-s3
              />
            </div>
            <label
              htmlFor={`${questionid}_slider`}
              className="valueHandle"
              id={`${questionid}_value_handle`}
            >
              {textValue}
            </label>
          </div>
        </div>
      </fieldset>
    </div>
  );
}
